<template>
  <RecordViewWrapper>
    <sdPageHeader title="Notification">
      <template #subTitle>
        <sdButton class="btn-add_new" size="default" type="primary" @click="readAllHandler">
          <sdFeatherIcons type="check" size="14" /> Tandai Semua Sudah Dibaca
        </sdButton>
      </template>
      <template #buttons>
        <div class="search-box">
          <span class="search-icon">
            <sdFeatherIcons type="search" size="14" />
          </span>
          <a-input
            @change="handleSearch"
            v-model:value.trim="formState.searchItem"
            type="text"
            name="recored-search"
            placeholder="Search Here"
          />
        </div>
      </template>
    </sdPageHeader>

    <Main>
      <a-row :gutter="15">
        <a-col class="w-100" :md="24">
          <sdCards headless>
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>

            <div v-else>
              <TableWrapper class="table-data-view table-responsive">
                <a-table
                  :pagination="{ pageSize: 10, showSizeChanger: true }"
                  :dataSource="dataSource"
                  :columns="columns"
                />
              </TableWrapper>
            </div>
          </sdCards>
        </a-col>
      </a-row>
    </Main>
  </RecordViewWrapper>
</template>

<script>
import { RecordViewWrapper } from '../../components/crud/style';
import { onMounted, reactive, ref, watch } from 'vue';
import { Main, TableWrapper } from '../styled';
import assessmentApi from '@/api/assessment';
import { getItem } from '@/utility/localStorageControl';

const columns = [
  {
    title: 'Time',
    dataIndex: 'time',
    key: 'name',
  },
  {
    title: 'Message',
    dataIndex: 'message',
    key: 'divisi_id',
  },
  {
    title: 'User',
    dataIndex: 'user_from',
    key: 'divisi_id',
  },
];

const ViewPage = {
  name: 'ViewPage',
  components: { RecordViewWrapper, Main, TableWrapper },
  setup() {
    const notifications = ref([]);
    const isLoading = ref(true);

    const formState = reactive({
      searchItem: '',
    });

    const fetchNotifications = (searchFilter = '') => {
      isLoading.value = true;
      const endpoint = searchFilter ? `notification-assessment?search=${searchFilter}` : 'notification-assessment';

      assessmentApi
        .get(endpoint, {
          headers: {
            Authorization: `Bearer ${getItem('access_token')}`,
          },
        })
        .then(response => {
          notifications.value = response.data.notifications || response.data;
          isLoading.value = false;
        })
        .catch(error => {
          console.error('Error fetching notifications:', error);
          isLoading.value = false;
        });
    };

    onMounted(() => {
      fetchNotifications();
    });

    const dataSource = ref([]);

    // Update dataSource whenever notifications change
    const updateDataSource = () => {
      dataSource.value = notifications.value.map((data, key) => {
        const { time, message, user_from, read_at, url, id } = data;
        const doc = new DOMParser().parseFromString(message, 'text/html');
        const text = doc.body.textContent;
        return {
          key: key + 1,
          time: !read_at ? <strong>{time}</strong> : time,
          message: !read_at ? (
            message ? (
              <router-link to={url} onClick={() => readHandler(id)}>
                <strong>{text}</strong>
              </router-link>
            ) : (
              ''
            )
          ) : message ? (
            <span>
              <router-link to={url}>{text}</router-link>
            </span>
          ) : (
            ''
          ),
          user_from: !read_at ? <strong>{user_from}</strong> : user_from,
        };
      });
    };

    // Watch for changes in notifications
    watch(notifications, updateDataSource, { immediate: true });

    const handleSearch = () => {
      fetchNotifications(formState.searchItem);
    };

    const readHandler = id => {
      assessmentApi
        .get(`read-notification-assessment/${id}`, {
          headers: {
            Authorization: `Bearer ${getItem('access_token')}`,
          },
        })
        .then(() => {
          fetchNotifications();
        });
    };

    const readAllHandler = () => {
      assessmentApi
        .get('read-all-notification-assessment', {
          headers: {
            Authorization: `Bearer ${getItem('access_token')}`,
          },
        })
        .then(() => {
          fetchNotifications();
        });
    };

    return {
      formState,
      columns,
      isLoading,
      dataSource,
      handleSearch,
      readAllHandler,
      readHandler,
    };
  },
};

export default ViewPage;
</script>
